module.exports = __webpack_public_path__ + "ofis-2.jpeg?f0382963dd77868612184ff69e2d1396";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/ofis-2.jpeg
// module id = 354
// module chunks = 0